import React from 'react'
import labels from '../../configuration/labels'
import placeholderImage from '../../assets/images/brand-placeholder.jpg'

const GridCardImage = ({ eventData }) => {
  let eventImage = placeholderImage

  if (eventData && eventData.image && eventData.image.path) {
    eventImage = eventData.image.path
  }

  return (
    <div
      className="event-image-src"
      style={{ backgroundImage: `url(${eventImage})` }}
    >
      {eventData.isClosed ? (
        <div className="event-image-notification closure">{labels.closedEventFlag}</div>
      ) : eventData.isFeatured ? (
        <div className="event-image-notification featured">{labels.featuredEventFlag}</div>
      ) : null}
      <img
        src={eventImage}
        alt={
          eventData.image && eventData.image.alt
            ? eventData.image.alt
            : 'Event Placeholder Image'
        }
      />
    </div>
  )
}

export default GridCardImage
